/**
 * Which screen an API call came from (job page v2, slice 6).
 *
 * `api.ts` sends this as `X-GWC-Screen` and the server stores it on the audit
 * row (`metadata.screen`), so in 30 days we can count real use of the classic
 * job page, the new job page, the Grid and Close Out, and re-pick the office's
 * default pins from that. Nothing on screen changes.
 *
 * The screen comes from the address bar. The job page says which version it
 * is (the per-user "Try the new job page" switch) while it is open.
 */
export type ApiScreen = "job_page_classic" | "job_page_new" | "job_page_fresh" | "grid" | "close_out";

/** "fresh" = the page rebuilt from a clean sheet (threads/job-page-fresh, 10/28). */
let jobPageVariant: "classic" | "new" | "fresh" | null = null;

/** The job page reports which version is showing; null when it closes. */
export function setJobPageVariant(v: "classic" | "new" | "fresh" | null): void {
    jobPageVariant = v;
}

export function screenForPath(pathname: string): ApiScreen | null {
    if (/^\/jobs\/[^/]+\/?$/.test(pathname)) {
        if (jobPageVariant === "fresh") return "job_page_fresh";
        if (jobPageVariant === "new") return "job_page_new";
        if (jobPageVariant === "classic") return "job_page_classic";
        return null;
    }
    if (/^\/dispatch\/?$/.test(pathname)) return "grid";
    if (/^\/close-out\/?$/.test(pathname)) return "close_out";
    return null;
}

/** The header value for a call made now, or null to send none. */
export function currentApiScreen(): ApiScreen | null {
    if (typeof window === "undefined") return null;
    return screenForPath(window.location.pathname);
}
